import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import axios from "axios";
import SrvButton from "../../../components/global/SrvButton";
import ErrorAdd from "../../../util/ErrorAdd";

function ModalAddTrial({ show, onHide }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    function activate() {
        axios.post('/api_tracker/billing/companyActivation', { ID_Status: 0 })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    onHide();
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Активация пробного периода</div>

                    <div className="text-center">
                        Пробный период действует 7 дней для 10 пользователей.
                        <br></br>
                        Пробный период можно активировать 1 раз
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="play" loading={loading} size={'lg'} onClick={() => activate()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
}
export default ModalAddTrial;
